import * as React from "react";
import { Link } from "gatsby";
import HeaderMenu from "../components/HeaderMenu/HeaderMenu";
import { withLayout, LayoutProps, menuItems } from "../components/Layout";
import Img from "gatsby-image";
import {
  Button,
  Segment,
  Container,
  Grid,
  Card,
  Header,
  Icon,
  Form,
  List,
  Item,
  Input,
} from "semantic-ui-react";
import { ImageSharp } from "../graphql-types";
import { graphql } from "gatsby";

const IndexPage = (props: LayoutProps) =>
  <div>
    {/* Master head */}
    <Segment vertical inverted textAlign="center" className="masthead">
      <HeaderMenu
        Link={Link} pathname={props.location.pathname} items={menuItems} inverted
      />
      <Container text>
        <Header inverted as="h1">Michelle A. Epstein, Ph.D.</Header>
        <Header inverted as="h2">Licensed Clinical Psychologist</Header>

      </Container>
    </Segment>

    {/* Key features */}
    <Segment secondary vertical className="stripe alternate feature">
      <Grid columns="3" textAlign="center" divided relaxed stackable className="container">
        <Grid.Row>
          <h3>Appearances on the WGN-TV Morning News</h3>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>

            <Header icon>
              What parents need to know about the new season of ’13 Reasons Why’ -  May 21, 2018
            </Header>
            <a href=
              "http://wgntv.com/2018/05/21/what-parents-need-to-know-about-the-new-season-of-13-reasons/"
              className="ui large image">

              <img src={props.data.file2.childImageSharp.fluid.src}
                srcSet={props.data.file2.childImageSharp.fluid.srcSet}></img>
            </a>
          </Grid.Column>

          <Grid.Column>
            <Header icon>
              Clinical psychologist talks mental health and ’13 Reasons Why’ -  May 9, 2017
            </Header>
            <a href=
    "http://wgntv.com/2017/05/09/clinical-psychologist-dr-michelle-epstein-talks-mental-health-and-13-reasons-why/"
              className="ui large image">

              <img src={props.data.file3.childImageSharp.fluid.src}
                srcSet={props.data.file3.childImageSharp.fluid.srcSet}></img>
            </a>
          </Grid.Column>
          <Grid.Column>
            <Header icon>
              Psychologist sheds light on how to treat anxiety - April 6, 2017
            </Header>
            <a href="http://wgntv.com/2017/04/06/psychologist-sheds-light-on-how-to-treat-anxiety/"
              className="ui large image">

              <img src={props.data.file4.childImageSharp.fluid.src}
                srcSet={props.data.file4.childImageSharp.fluid.srcSet}></img>
            </a>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
    {/* About this starter */}
    <Segment vertical className="stripe">
      <Grid stackable verticalAlign="middle" className="container">
        <Grid.Row>
          <Grid.Column width="4">
          </Grid.Column>
          <Grid.Column width="8">
            <Header icon as="h1">
              Dr. Michelle A. Epstein
      </Header>
            {/* <img src={props.data.file1.childImageSharp.fluid.src}
                srcSet={props.data.file1.childImageSharp.fluid.srcSet} height="200" width="150"></img>

                */}
            <Header></Header>
            <p>
              A Licensed Clinical Psychologist and regular On-Air Contributor to WGN-TV Morning News.
               Dr. Epstein was awarded a PhD in Clinical Psychology from the University of Illinois
               at Chicago and completed a Clinical Internship at the Children’s Hospital at Harvard
               Medical School in Boston. She also completed a Fellowship in Trauma at La Rabida
               Children’s Hospital in Chicago.
            </p>
            <p>
              Dr. Epstein also sits on the Advisory Board of the Rebecca's Dream Foundation - a
              nonprofit organization whose mission is to promote awareness and reduce stigma associated
               with Mental Illness through education about Depression and Bipolar Disorder as real diseases.
                Dr. Epstein provides consultation to the Board of Directors and assists in development
                and implementation of educational programming designed to further the mission of
                Rebecca's Dream.
            </p>
            <p>
              Dr. Epstein brings over 20 years of clinical experience to her practice in which
               she treats adults and older adolescents. Her expertise include: Depression &amp;
                Anxiety, Chronic Stress, Emotional Trauma, Grief &amp; Loss (e.g., Death, Divorce
                   &amp; Infertility), Marital Stress &amp; Dissatisfaction, Parenting Issues, Body
                    Image Issues, Self- Esteem and Major Life Transitions (e.g., College, Post-College
                       &amp; Empty Nesthood).
            </p>
            <p>
              Dr. Epstein provides highly individualized treatment specifically tailored to meet each
               individual’s needs. She considers the whole person, including strengths and weaknesses,
                and utilizes this information to devise treatments that are solution-focused and empower
                 individuals with concrete tools and insights to improve their overall mental health and wellbeing.
            </p>

          </Grid.Column>
          <Grid.Column width="6" floated="right">
            {/* TODO replace with a pretty GIF */}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
    <Segment secondary vertical className="stripe alternate feature">
      <Grid stackable verticalAlign="middle" textAlign="center" >
        <Grid.Row>
          <Header icon as="h1">
            Contact me:
          </Header>
        </Grid.Row>
        <Grid.Row>
            <Container textAlign="center">
          <Header as="h2">
            <a href="mailto:drmepstein@hotmail.com">drmepstein@hotmail.com</a>
          </Header>
          <div>
          </div>
        </Container>

        </Grid.Row>
        <Grid.Row>
            <Container textAlign="center">
          <Header as="h2">
            <a href="tel:+18477028777">
              +1 (847) 702-8777
              </a>
          </Header>
          <div>
          </div>
        </Container>

        </Grid.Row>
        <Grid.Row>

          <Container textAlign="center">
            <h2>  <a href="https://goo.gl/maps/UV199aLj8cr">  155 North Pfingsten Rd. Suite 350
      Deerfield, IL 60015 </a>
    </h2>
          </Container>
        </Grid.Row>
      </Grid>
    </Segment>

  </div>;

export default withLayout(IndexPage);

export const query = graphql`
query GatsbyImageSampleQuery {
  file1: file(relativePath: {eq: "siteimages/HS-Michelle-Epstein.jpg"}) {
    childImageSharp {
            fluid {
        src
        srcSet
      }
    }
  }
  file2: file(relativePath: {eq: "siteimages/wgn-5-21-18.png"}) {
    childImageSharp {
            fluid {
        src
        srcSet
      }
    }
  }
  file3: file(relativePath: {eq: "siteimages/wgn-5-9-17.png"}) {
    childImageSharp {
            fluid {
        src
        srcSet
      }
    }
  }
  file4: file(relativePath: {eq: "siteimages/wgn-4-6-17.png"}) {
    childImageSharp {
            fluid {
        src
        srcSet
      }
    }
  }
}
`;
